/* eslint-disable no-console */
//
// File Browser script
//

const SELECTOR_FILE_BROWSER = '[data-sc3d-dropbox-file-browser]';
const SELECTOR_SEARCH_INPUT = '[data-sc3d-dropbox-search-input]';
const SELECTOR_SEARCH_BUTTON = '[data-sc3d-dropbox-search-button]';
const SELECTOR_SEARCH_LOADER = '[data-sc3d-dropbox-search-loader]';
const SELECTOR_SEARCH_RESULTS = '[data-sc3d-dropbox-search-results]';

//
//
//
document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll<HTMLElement>(SELECTOR_FILE_BROWSER).forEach((fileBrowser) => initializeFileBrowser(fileBrowser));
});

const requestedFolders: string[] = [];

function initializeFileBrowser(fileBrowser: HTMLElement) {
	let lastSearchValue: string | null = null;
	let searchN: number = 0;

	const searchInput = fileBrowser.querySelector<HTMLInputElement>(SELECTOR_SEARCH_INPUT);
	const searchButton = fileBrowser.querySelector<HTMLButtonElement>(SELECTOR_SEARCH_BUTTON);
	const searchLoader = fileBrowser.querySelector<HTMLDivElement>(SELECTOR_SEARCH_LOADER);
	const searchResultsContainer = fileBrowser.querySelector<HTMLDivElement>(SELECTOR_SEARCH_RESULTS);

	if (!searchInput || !searchButton || !searchLoader || !searchResultsContainer) {
		return;
	}

	const search = (searchValue: string = '') => {
		if (searchValue === lastSearchValue) {
			return;
		}
		lastSearchValue = searchValue;
		searchN = searchN + 1;
		const thisSearchN = searchN;

		const searchRequest = new XMLHttpRequest();
		searchRequest.open('POST', window.SC3D_DROPBOX.ajaxUrl + '?action=sc3d-dropbox-file-browser-search&q=' + searchValue, true);
		searchRequest.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
		searchRequest.onload = () => {
			if (searchN !== thisSearchN) {
				return;
			}
			searchLoader.style.display = 'none';
			searchResultsContainer.innerHTML = searchRequest.responseText;

			document.querySelectorAll('[data-sc3d-dropbox-folder-collapse]').forEach(function (el) {
				el.addEventListener('show.bs.collapse', function (e: any) {
					// make a request to get the files in the folder
					const folderId = e.target.getAttribute('data-sc3d-dropbox-folder-collapse');
					const folderFiles = e.target.querySelector('[data-sc3d-dropbox-folder-files]');

					if (requestedFolders.includes(folderId)) {
						return;
					}

					requestedFolders.push(folderId);

					searchRequest.open('POST', window.SC3D_DROPBOX.ajaxUrl + '?action=sc3d-dropbox-load-file-list&folder=' + folderId, true);
					searchRequest.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
					searchRequest.onload = () => {
						folderFiles.innerHTML = searchRequest.responseText;
					};
					searchRequest.send();
				});
			});
		};

		searchLoader.style.display = 'flex';
		searchRequest.send();
	};

	searchInput.addEventListener('keyup', (event) => event.key === 'Enter' && search(searchInput.value));

	// debounce search for any key press
	searchInput.addEventListener(
		'keyup',
		debounce(() => search(searchInput.value), 1000)
	);

	searchButton.addEventListener('click', () => search(searchInput.value));

	search(searchInput.value);
}

function debounce(func: Function, wait: number) {
	let timeout: any;
	return function (...args: any[]) {
		const context = this;
		const later = () => {
			timeout = null;
			func.apply(context, args);
		};
		if (timeout) {
			clearTimeout(timeout);
		}
		timeout = setTimeout(later, wait);
	};
}
